<template>
  <div class="open-platform">
    <div class="banner">
      <div class="v-page-center div-center text-center">
        <div class="title">通过开放平台进行开发对接</div>
        <div class="sub-title">
          我们的AIGC产品，智能硬件产品和SaaS平台，均可以与您已有的软件平台、信息化系统和存量设备对接。
        </div>
      </div>
    </div>
    <div class="content flex-center">
      <img style="width: 428px; height: 428px" src="@/assets/image/open-platform/bg_rel.png" alt="敬请期待, 欢迎联系" />
      <div class="contact-information flex-between-center">
        <div class="contact-information_item flex-side-center">
          <img src="@/assets/image/open-platform/icon_wechat_blue.png" alt="企业微信" />
          <div>
            <p style="color: #061d44; font-size: 16px">{{ footer.links[0].value }}</p>
            <p style="color: #4e5969; font-size: 14px">{{ footer.links[0].label }}</p>
          </div>
        </div>
        <div class="contact-information_item flex">
          <img src="@/assets/image/open-platform/icon_mail_blue.png" alt="企业微信" />
          <div>
            <p style="color: #061d44; font-size: 16px">{{ footer.links[1].value }}</p>
            <p style="color: #4e5969; font-size: 14px">{{ footer.links[1].label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scroll from '@/mixins/scroll'
import { footer } from '@/config'

export default {
  name: 'OpenPlatform',
  mixins: [scroll],
  data() {
    return {
      footer,
    }
  },
}
</script>

<style scoped lang="scss">
.open-platform {
  .banner {
    padding-top: 120px;
    height: 230px;
    background: url('~@/assets/image/app-center/app-banner.png') no-repeat center / 100% 100%;
    .title {
      margin-bottom: 8px;
      @include fc(28px, 500, #061d44);
    }
    .sub-title {
      @include fc(22px, 400, #626973);
    }
  }
  .content {
    position: relative;
    .contact-information {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 428px;
      &_item {
        img {
          margin-right: 8px;
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}
</style>
